import React from "react";
import { $applyNodeReplacement, DecoratorNode, LexicalNode, NodeKey, SerializedLexicalNode, Spread } from "lexical";

export type SerializedOperatorNode = Spread<
  { value: string },
  SerializedLexicalNode
>;


export class OperatorNode extends DecoratorNode<JSX.Element> {
  __value: string;

  static getType() {
    return "operator";
  }

  static clone(node: OperatorNode) {
    return new OperatorNode(node.__value, node.__key);
  }

  constructor(value: string, key?: NodeKey) {
    super(key);
    this.__value = value;
  }

  createDOM(): HTMLElement {
    const span = document.createElement("span");
    span.setAttribute("data-lexical-operator", this.__value);
    span.contentEditable = "false";
    Object.assign(span.style, {
      fontWeight: "bolder",
      fontSize: "16px",
      color: "var(--color-blue, #0078d4)",
      display: "inline",
      whiteSpace: "pre",
    });
    return span;
  }

  updateDOM(): false {
    return false;
  }

  decorate(): JSX.Element {
    return (
      <span>
        {this.__value}
      </span>
    );
  }

  exportJSON(): SerializedOperatorNode {
    return { type: "operator", version: 1, value: this.__value };
  }

  static importJSON(json: SerializedOperatorNode): OperatorNode {
    return $createOperatorNode(json.value);
  }

  isInline() {
    return true;
  }

  isKeyboardSelectable() {
    return false;
  }

  getTextContent() {
    return this.__value;
  }
}

export function $createOperatorNode(value: string): OperatorNode {
  return $applyNodeReplacement(new OperatorNode(value));
}

export function $isOperatorNode(node: LexicalNode | null | undefined): node is OperatorNode {
  return node instanceof OperatorNode;
}

